import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import {
  DragDropContext,
  Draggable,
  Droppable,
  resetServerContext,
} from 'react-beautiful-dnd';
import CheckboxAdapter from '../CheckboxAdapter.jsx';
import { FormError } from '../FormError.jsx';
import { navigateToChangeInsightDetails } from '../links/index.jsx';

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'none' : 'none',
});

const ChangeInsightsSettingForm = (props) => {
  const {
    submitError,
    submitFailed,
    loading,
    handleSubmit,
    onDragEnd,
    onDashboardShowChange,
    data,
  } = props;

  resetServerContext();

  const onCancel = () => {
    navigateToChangeInsightDetails();
  };
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          {data.length ? (
            <p className="text-muted m-b-24">
              Click "Show in the Dashboard" to customize which question's
              results you'd like to see in the Feedback Dashboard.
            </p>
          ) : (
            <p className="text-muted m-b-24">
              There are no questions available to be displayed on the dashboard.
              To view charts on the dashboard, please use question types other
              than text fields in your feedback form.
            </p>
          )}
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {data.map((item, index) => (
                    <Draggable
                      key={item.draggableId}
                      draggableId={item.draggableId}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <Row>
                            <Col xs={1}>
                              <span
                                className="btn-move btn btn-default"
                                {...provided.dragHandleProps}
                              ></span>
                            </Col>
                            <Col xs={6}>
                              <div
                                className="flex m-b-10 m-t-8"
                                id={item.draggableId}
                              >
                                <p
                                  className="text-normal"
                                  style={{
                                    fontWeight: '500',
                                    fontSize: '16px',
                                  }}
                                >
                                  {item.title}
                                </p>
                              </div>
                            </Col>
                            <Col xs={3}>
                              <Field
                                name={item.name}
                                label="Show in the Dashboard"
                                type="checkbox"
                                component={CheckboxAdapter}
                                checked={item.dashboardShow}
                                onClick={() => onDashboardShowChange(item.id)}
                              />
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
      </Row>
      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <Button bsStyle="default" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={loading || !data.length}
                onClick={handleSubmit}
              >
                {loading ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ChangeInsightsSettingForm;
